<template>
  <div class="marketing-automation-form-panel-sms">
    <app-form @submit="setStep">
      <marketing-automation-form-panel-section :title="$t('message.automation.message.setSms')">
        <app-select class="marketing-automation-form-panel-sms-section-select"
                    v-model="form.smsId"
                    :data-items="smsOptions"
                    :infiniteId="infiniteId"
                    :data-title="$t('message.automation.message.setSms')"
                    data-menu-width="200px"
                    titleMaxWidth="250px"
                    infinite-loading
                    small
                    @search="searchOptions"
                    @load="loadSmsOptions"
                     />
      </marketing-automation-form-panel-section>

      <marketing-automation-form-panel-section>
        <button class="marketing-automation-form-panel-sms-section-action btn btn-round btn-primary"
                type="submit">{{ actionText }}</button>
      </marketing-automation-form-panel-section>
    </app-form>
  </div>
</template>

<script>
import AppSelect from "@components/Select";
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";
import AppForm from "@components/form/Form.vue";

export default {
  components: {
    AppForm,
    MarketingAutomationFormPanelSection,
    AppSelect,
  },

  props: {
    step: {
      type: Object,
    },
    automationId: {
      type: String,
    },
  },

  data() {
    return {
      smsOptions: [],
      page: 0,
      filter: undefined,
      infiniteId: +new Date(),
      form: {
        smsId: undefined,
      },
    };
  },

  created() {
    if (this.step) {
      this.setInitialData();
    }
  },

  computed: {
    actionText() {
      return this.step ? this.$t('message.generics.message.save') : this.$t('message.generics.message.add');
    },
  },

  methods: {
    async setInitialData() {
      await this.loadSmsOptions();

      this.form.smsId = this.step.properties.messageId;
    },
    setStep() {
      if (this.step && this.step.id) {
        this.editStep();
      } else {
        this.addStep();
      }
    },
    async addStep() {
      const steps = await this.$api.marketing.automation.flow.addStep({
        automationId: this.automationId,
        stepType: "CHANNEL",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          channelType: "SMS",
          messageId: this.form.smsId,
        }),
      });

      this.$emit("submit", steps);
    },
    async editStep() {
      const steps = await this.$api.marketing.automation.flow.editStep({
        stepId: this.step.id,
        automationId: this.automationId,
        stepType: "CHANNEL",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          channelType: "SMS",
          messageId: this.form.smsId,
        }),
      });

      this.$emit("submit", steps);
    },
    searchOptions(text) {
      this.filter = text;
      this.reload();
    },
    reload() {
      this.page = 0;
      this.smsOptions = [];
      this.infiniteId++;
    },
    async loadSmsOptions($state) {
      const list = await this.$api.marketing.sms.message.list({
        page: this.page,
        filter: this.filter,
        isAutomation: true,
      });

      const formatedOptionsList = list.map((sms) => {
        return {
          id: sms.id,
          label: sms.title,
        };
      });

      this.smsOptions.push(...formatedOptionsList);

      this.page += 1;

      if (list.length) {
        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-panel-sms {
  .marketing-automation-form-panel-sms-section-select {
    margin: 0 auto;
  }

  .marketing-automation-form-panel-sms-section-action {
    margin: 0 auto;
    display: block;
  }
}
</style>
